import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSortable } from "@dnd-kit/sortable";
import { useMemo } from "react";
import { getSortableItemStyles, visibleHeader } from "~/utils/configurableViewFieldsUtils";
const ViewVisibilityHeader = (param)=>{
    let { option, onClick } = param;
    const sortableProps = useSortable({
        id: option.derivedId,
        disabled: true
    });
    const style = useMemo(()=>getSortableItemStyles(sortableProps), [
        sortableProps
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "flex cursor-default flex-col",
        ref: sortableProps === null || sortableProps === void 0 ? void 0 : sortableProps.setNodeRef,
        style: style,
        ...sortableProps === null || sortableProps === void 0 ? void 0 : sortableProps.attributes,
        "data-no-dnd": true,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center justify-between px-1.5 py-2 text-12 font-medium leading-[18px] text-grey-9",
            children: [
                /*#__PURE__*/ _jsx("span", {
                    children: option.label
                }),
                /*#__PURE__*/ _jsx("button", {
                    className: "cursor-pointer text-grey-11",
                    onClick: ()=>onClick(option.derivedId === visibleHeader.derivedId ? false : true),
                    children: option.derivedId === visibleHeader.derivedId ? "Hide all" : "Show all"
                })
            ]
        })
    });
};
ViewVisibilityHeader.displayName = "ViewVisibilityHeader";
export default ViewVisibilityHeader;
